import React, { useRef, useEffect, useState } from "react";
import { useSelector, shallowEqual, connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { Row, Col, Button, Form, Modal, InputGroup } from "react-bootstrap";
import PasswordChecklist from "react-password-checklist";
import { selectUser } from "../../modules/Auth/_redux/authRedux";
import { showDialog, showErrorDialog, showSuccessDialog } from "../../utility";

import LoadingFetchData from "../../../app/utility/LoadingFetchData";
import { LayoutSplashScreen, useSubheader } from "../../../_metronic/layout";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
// MUI
import clsx from "clsx";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { selectLoading, updatePassword } from "../../pages/user/userSlice";

// MUI
import { makeStyles, fade, styled } from "@material-ui/core/styles";
import { FormHelperText, InputAdornment, TextField } from "@material-ui/core";

const RedditTextField = styled((props) => (
  <TextField InputProps={{ disableUnderline: true }} {...props} />
))(({ theme }) => ({
  "& .MuiFilledInput-root": {
    borderRadius: 4,
    background: "none",
    border: "1px solid #e2e2e1",
  },
  "& .MuiInputLabel-root": {
    background: "none",
  },
  "& .MuiInputBase-input": {
    background: "none",
  },
}));

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const ChangePassword = (props) => {
  const suhbeader = useSubheader();
  suhbeader.setTitle("Change Password");
  const classes = useStyles();
  const user = useSelector(selectUser);
  const loading = useSelector(selectLoading);
  const history = useHistory();
  const dispatch = useDispatch();
  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [otpId, setOtpId] = useState("");
  const [channelOtp, setChannelOtp] = useState("");
  const [overlayLoading, setOverlayLoading] = useState(false);

  const [passwordShown, setPasswordShown] = useState(false);
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };
  const icon = <SVG src={toAbsoluteUrl("/media/svg/icons/New/x-error.svg")} />;

  const [formValues, setFormValues] = useState({
    password_old: {
      value: "",
      error: false,
      required: "Y",
    },
    password: {
      value: "",
      error: false,
      required: "Y",
    },
    password_again: {
      value: "",
      error: false,
      required: "Y",
    },
  });
  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);

    console.log(isValid, "isValid");
    return isValid;
  };
  const handleSave = async () => {
    if (!validatePost()) {
      return;
    }
    // cek password

    if (formValues.password.value === formValues.password_again.value) {
    } else {
      showErrorDialog("New password and confirmation password must match");
      return;
    }

    const params = {
      old_password: formValues.password_old.value,
      new_password: formValues.password.value,
    };

    let objJsonStr = JSON.stringify(params);

    let objJsonB64 = Buffer.from(objJsonStr).toString("base64");

    const dataBase64 = {
      encryptedData: objJsonB64,
    };

    try {
      const response = await dispatch(updatePassword(dataBase64));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const [values, setValues] = React.useState({
    password: "",
    oldPassword: "",
    passwordAgain: "",

    showPassword: false,
  });

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <LoadingFetchData active={overlayLoading} />

        <CardBody>
          <div>
            <Row>
              <Col xs={12} sm={3} md={4} lg={4}>
                <RedditTextField
                  required
                  label="Old Password"
                  className={classes.margin}
                  variant="filled"
                  id="reddit-input"
                  size="small"
                  type={values.showPassword ? "text" : "password"}
                  fullWidth
                  name="password_old"
                  value={formValues.password_old.value}
                  onChange={handleChange}
                  error={formValues.password_old.error}
                  helperText={
                    formValues.password_old.error ? (
                      <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                        {icon} {"This field is required"}
                      </FormHelperText>
                    ) : (
                      ""
                    )
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          edge="end"
                          aria-label="Toggle password visibility"
                          onClick={handleClickShowPassword}
                        >
                          {values.showPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3} md={4} lg={4}>
                <RedditTextField
                  required
                  label="New Password "
                  className={classes.margin}
                  variant="filled"
                  id="reddit-input"
                  size="small"
                  type={values.showPassword ? "text" : "password"}
                  fullWidth
                  name="password"
                  value={formValues.password.value}
                  onChange={handleChange}
                  error={formValues.password.error}
                  helperText={
                    formValues.password.error ? (
                      <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                        {icon} {"This field is required"}
                      </FormHelperText>
                    ) : (
                      ""
                    )
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          edge="end"
                          aria-label="Toggle password visibility"
                          onClick={handleClickShowPassword}
                        >
                          {values.showPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3} md={4} lg={4}>
                <RedditTextField
                  required
                  label="Confirm Password"
                  className={classes.margin}
                  variant="filled"
                  id="reddit-input"
                  size="small"
                  type={values.showPassword ? "text" : "password"}
                  fullWidth
                  name="password_again"
                  value={formValues.password_again.value}
                  onChange={handleChange}
                  error={formValues.password_again.error}
                  helperText={
                    formValues.password_again.error ? (
                      <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                        {icon} {"This field is required"}
                      </FormHelperText>
                    ) : (
                      ""
                    )
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          edge="end"
                          aria-label="Toggle password visibility"
                          onClick={handleClickShowPassword}
                        >
                          {values.showPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                <PasswordChecklist
                  rules={[
                    "minLength",
                    "specialChar",
                    "number",
                    "capital",
                    "match",
                  ]}
                  minLength={8}
                  value={formValues.password.value}
                  valueAgain={formValues.password_again.value}
                  messages={{
                    minLength: "Password Minimum 8 Length",
                    specialChar: "Password Special Char Minimum Length",
                    number: "Password Number Minimum Length",
                    capital: "Password Upper Case Minimum Length",
                    match: "Password dont Match",
                  }}
                />
                <Row className="mt-6 justify-content-end">
                  <Button variant="primary" onClick={handleSave}>
                    Save
                  </Button>
                </Row>
              </Col>
            </Row>
          </div>
        </CardBody>
      </Card>
    </>
  );
};
